module.exports = __webpack_public_path__ + "images/emoji/postbox.92e2834eeea1707bf5da.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/postbox.png
// module id = 3tA4
// module chunks = 13